import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from './classes/BaseService';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ReviewsService extends BaseService{

  apiUrl = "Review.php?"

  constructor(protected http: HttpClient) {
    super(http);
  }

  create(title: string, text: string, rating: number, idInStore: string, store: string, sessionToken: string, country: string, itemType: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "create"),
      new UrlParam("title", title),
      new UrlParam("text", text),
      new UrlParam("rating", rating.toString()),
      new UrlParam("idInStore", idInStore),
      new UrlParam("itemType", itemType),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.post(url, params);
  }

  edit(reviewId: number, title: string, text: string, rating: number, idInStore: string, store: string, sessionToken: string, country: string, itemType: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("id", reviewId.toString()),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "edit"),
      new UrlParam("title", title),
      new UrlParam("text", text),
      new UrlParam("rating", rating.toString()),
      new UrlParam("idInStore", idInStore),
      new UrlParam("itemType", itemType),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.post(url, params);
  }

  doUpvote(reviewId: number, store: string, sessionToken: string, country: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("id", reviewId.toString()),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "doUpvote"),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.post(url, params);
  }

  doDownvote(reviewId: number, store: string, sessionToken: string, country: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("id", reviewId.toString()),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "doDownvote"),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.post(url, params);
  }

  getReviewsForItem(idInStore: string, store: string, country: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "getReviewsForItem"),
      new UrlParam("idInStore", idInStore)
    );
    return this.get(url)
  }

}
